import {apiService} from '../apiService';

export const felicityService = apiService.injectEndpoints({
    endpoints: (builder) => {
        return {
            getFelicityPass: builder.query({
                query: () => ({
                    url: '/felicity/pass'
                })
            })
        };
    }
});

export const {useLazyGetFelicityPassQuery} = felicityService;
